import React from 'react';
import { LeaderboardWithResults } from '../../models/LeaderboardWithResults';
import { LeaderboardWithRecentResults } from '../../models/LeaderboardWithRecentResults';
import { formatMilliseconds, formatDateOnlyLocal } from '../../utils/time';
import { formatLocation } from '../../utils/bookingUtils';
import './ResultsTable.css';

interface ResultsTableProps {
    results: LeaderboardWithResults | LeaderboardWithRecentResults | null;
    showDate?: boolean;
    type?: string;
}

const ResultsTable: React.FC<ResultsTableProps> = ({ results, showDate = true, type }) => {

    function getArrow(isPersonalBest: boolean) {
        if (isPersonalBest) {
            return "▲";
        }
        return "▼";
    }

    return (
        <div className="table-container" style={{ fontSize: '14px' }}>
            <div>
                <table className="race-results">
                    <thead>
                        <tr>
                            <th>Pos</th>
                            <th>Driver</th>
                            <th className="hide-mobile">Sec1</th>
                            <th className="hide-mobile">Sec2</th>
                            <th className="hide-mobile">Sec3</th>
                            <th>Time</th>
                            {results?.leaderboard.showDeltas && <th className="hide-mobile">Delta</th>}
                             {!type && <th>Location</th> }
                           {showDate && <th>Date</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {results?.items.map((r: any, index) => {
                            const position = r.position  || (index + 1);
                            const driver = r.driver || r.driverName;
                            const deltaLeader = r.deltaFromFirst !== undefined ? r.deltaFromFirst : r.deltaFromLeader;

                            return (
                                <tr key={index}>
                                    <td>{r.isPersonalBest !== undefined ?(
                                    <>{position} <span style={{ color: r.isPersonalBest ? '#28a745' : '#dc3545' }}>{getArrow(r.isPersonalBest)}</span></>
                                    ) : position}</td>
                                    <td>{driver}</td>
                                    <td className="hide-mobile">{formatMilliseconds(r.sec1)}</td>
                                    <td className="hide-mobile">{formatMilliseconds(r.sec2)}</td>
                                    <td className="hide-mobile">{formatMilliseconds(r.sec3)}</td>
                                    <td>{formatMilliseconds(r.time)}</td>
                                    {results?.leaderboard.showDeltas && (
                                        <td className={deltaLeader > 0 ? "hide-mobile delta-positive" : "hide-mobile delta"}>
                                            { deltaLeader === 0 ? "🏆:🏆:🏆" : formatMilliseconds(deltaLeader)}
                                        </td>
                                    )}
                                    {!type &&
                                    <td>{formatLocation(r.location)}</td>
                                    }
                                    {showDate && <td>{formatDateOnlyLocal(r.createdAt.toString())}</td>}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ResultsTable;
